import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4307a3d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-4xl mb-4 font-semibold text-gray-500"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  hidden: ""
}, null, -1))
const _hoisted_3 = { class: "text-lg" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "Description:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "Percentage:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "Amount (paise):", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "Last Day:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "User Email", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "Game Key", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "Used", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "Stackable", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, " "),
  /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, [
    /*#__PURE__*/_createElementVNode("button", { class: "text-md uppercase text-white font-semibold py-2 px-3 bg-indigo-600 rounded-lg" }, " Submit ")
  ])
], -1))

import { onBeforeMount, reactive } from 'vue';
import * as luxon from 'luxon';

import { logger } from '@/utils';
import api from '../models/api';
import { useRouter } from 'vue-router';

type Coupon = {
    lastDay?: string,
    description: string,
    used: boolean,
    stackable: boolean,
    percentage?: number,
    amountPaise?: number,
    userEmail?: string,
    gameKey?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Coupon',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;
const router = useRouter();

const coupon = reactive({ used: false, stackable: true } as Coupon);

const save = async() => {
    if (!coupon.lastDay) {
        logger.warn('Date not specified.');
        return;
    }

    const disable = luxon.DateTime.fromFormat(coupon.lastDay, 'yyyy-MM-dd');
    if (!disable.isValid) {
        logger.warn(`Could not parse the date from ${coupon.lastDay}`);
        return;
    }

    const couponEntity = {
        ...coupon,
        disable
    };
    delete couponEntity.lastDay;
    const response = (await (props.id ? 
        api.put(`/DROW8HYBVATS/coupons/${props.id}`, couponEntity) :
        api.post(`/DROW8HYBVATS/coupons`, couponEntity))).data;
    await router.replace(`/DROW8HYBVATS/admin/dashboard/coupons/${response.code}`);
}

onBeforeMount(async () => {
    if (!props.id) return;
    const couponData = (await api.get(`/coupons/${props.id}`)).data;
    coupon.lastDay = luxon.DateTime.fromISO(couponData.disable).toISODate();
    Object.assign(coupon, couponData)
    delete (coupon as any).disable;
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (save()), ["prevent"])),
    class: "w-full px-4 py-8"
  }, [
    (props.id)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.id), 1))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createElementVNode("tbody", _hoisted_3, [
      _createElementVNode("tr", null, [
        _hoisted_4,
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((coupon.description) = $event))
          }, null, 512), [
            [_vModelText, coupon.description]
          ])
        ])
      ]),
      _createElementVNode("tr", null, [
        _hoisted_5,
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((coupon.percentage) = $event))
          }, null, 512), [
            [_vModelText, coupon.percentage]
          ])
        ])
      ]),
      _createElementVNode("tr", null, [
        _hoisted_6,
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((coupon.amountPaise) = $event))
          }, null, 512), [
            [_vModelText, coupon.amountPaise]
          ])
        ])
      ]),
      _createElementVNode("tr", null, [
        _hoisted_7,
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((coupon.lastDay) = $event))
          }, null, 512), [
            [_vModelText, coupon.lastDay]
          ])
        ])
      ]),
      _createElementVNode("tr", null, [
        _hoisted_8,
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "email",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((coupon.userEmail) = $event))
          }, null, 512), [
            [_vModelText, coupon.userEmail]
          ])
        ])
      ]),
      _createElementVNode("tr", null, [
        _hoisted_9,
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((coupon.gameKey) = $event))
          }, null, 512), [
            [_vModelText, coupon.gameKey]
          ])
        ])
      ]),
      _createElementVNode("tr", null, [
        _hoisted_10,
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((coupon.used) = $event)),
            class: _normalizeClass([ coupon.used ? 'bg-blue-400' : 'bg-white' ])
          }, null, 2), [
            [_vModelCheckbox, coupon.used]
          ])
        ])
      ]),
      _createElementVNode("tr", null, [
        _hoisted_11,
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((coupon.used) = $event)),
            class: _normalizeClass([ coupon.stackable ? 'bg-blue-400' : 'bg-white' ])
          }, null, 2), [
            [_vModelCheckbox, coupon.used]
          ])
        ])
      ]),
      _hoisted_12
    ])
  ], 32))
}
}

})